module.exports = __webpack_public_path__ + "assets/img/icon_file.svg";